import { NewAdminForm } from "./_components/new-admin-form";

const CreateNewAdmin = () => {
  return (
    <div className="md:h-[calc(100%-56px)] h-[calc(100vh-56px)]">
      <div className="h-full rounded-md">
        <NewAdminForm />
      </div>
    </div>
  );
};

export default CreateNewAdmin;
